import { post } from "state/actions/api";

export const buildTheme = (context) => (theme) => {
    return post(context)(`console/themes/${theme}/build`, {}, "buildTheme");
};
